requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    if (!window.navJsLoaded) {
      scriptController.executeWhenScriptLoaded('animation.js', () => {
        class NavigationControler {
          constructor() {
            this.onResizeHandler = this.onResize.bind(this);
            this.init();
          }

          init() {
            window.removeEventListener('throttle30fpsResize', this.onResizeHandler);

            this.wrapper = window.themeHeader?.getWrapper?.() || document.querySelector('.header-sections-wrapper');
            this.headerSections = window.themeHeader?.getDesktopStackSections?.() || [];
            this.headerSection = window.themeHeader?.getDesktopPrimarySection?.() || window.themeHeader?.getPrimarySection?.() || document.getElementsByTagName('header-section')[0];

            this.buttons = [];
            this.megaMenus = [];
            this.megaMenuHosts = [];
            this.dropdownMenus = [];
            this.animateItemsRoots = [];
            this.dataOpenOnclick = false;

            if ((!this.headerSection && !this.headerSections.length) || !this.wrapper) {
              this.resetSharedStates();
              return;
            }

            if (!this.headerSections.length && this.headerSection) {
              this.headerSections = [this.headerSection];
            }

            this.buttons = this.headerSections.flatMap((section) => Array.from(section.querySelectorAll('[data-menu-button]')));
            this.megaMenus = Array.from(this.wrapper.querySelectorAll('mega-menu'));
            this.megaMenuHosts = Array.from(this.wrapper.querySelectorAll('.mega-menus'));
            this.dropdownMenus = this.headerSections.flatMap((section) => Array.from(section.querySelectorAll('dropdown-menu, popup-menu-dropdown')));
            this.dataOpenOnclick = this.buttons.some((element) => this.isOpenOnClickElement(element));
            this.animateItemsRoots = this.headerSections.flatMap((section) => Array.from(section.querySelectorAll('[data-animate-items]')));

            if (this.animateItemsRoots.length) {
              window.addEventListener('throttle30fpsResize', this.onResizeHandler);
              this.onResizeHandler();
            }

            this.buttons.forEach(element => {
              const hasDropdownMenu = !!element.closest('dropdown-menu');
              const hasMegaMenu = !!this.getMegaMenuByHandle(element.dataset.menuButton, element);

              if (!element.hasAttribute('data-navigation-bound')) {
                const handler = this.onButtonsMouseenter.bind(this, element, hasDropdownMenu, hasMegaMenu);
                if (element.dataset.action === 'hover') {
                  element.addEventListener('mouseenter', handler);
                } else {
                  element.addEventListener(this.isOpenOnClickElement(element) ? 'click' : 'mouseenter', handler);
                }

                element.setAttribute('data-navigation-bound', 'true');
              }

              element.classList.add('button-navigation-script-loaded');
            });

            this.resetSharedStates();
          }

          isOpenOnClickElement(element) {
            if (element?.hasAttribute('data-menu-button-link-navigation')) {
              return false;
            }

            const ownerSection = element?.closest('header-section[data-header-layout]');
            const menuRoot = element?.closest('[data-header-menu-block], .header__inline-menu, .header__icons-menu');

            return !!(menuRoot?.hasAttribute('data-open-onclick') || ownerSection?.hasAttribute('data-open-onclick'));
          }

          toggleSharedState(className, enabled) {
            this.wrapper?.classList.toggle(className, enabled);
            document.body.classList.toggle(className, enabled);
          }

          resetMenus() {
            this.wrapper?.querySelectorAll('.mega-menu--visible').forEach((element) => {
              if (typeof element.megaMenuCloseWithoutAnimation === 'function') {
                element.megaMenuCloseWithoutAnimation();
              } else {
                element.classList.remove('mega-menu--active', 'mega-menu--visible');
              }
            });

            this.wrapper?.querySelectorAll('.dropdown-menu--visible').forEach((element) => {
              if (typeof element.dropdownMenuCloseWithoutAnimation === 'function') {
                element.dropdownMenuCloseWithoutAnimation();
              } else {
                element.classList.remove('dropdown-menu--active', 'dropdown-menu--visible');
              }
            });
          }

          resetSharedStates() {
            this.resetMenus();
            this.toggleSharedState('mega-menu-visible', false);
            this.toggleSharedState('mega-menu-active', false);
            this.toggleSharedState('dropdown-menu-visible', false);
            this.toggleSharedState('dropdown-menu-active', false);
            this.backgroundCloseWithoutAnimation();
          }

          onResize() {
            this.calculateItemsAnimatedElements();
          }

          onButtonsMouseenter(button, hasDropdownMenu, hasMegaMenu, event) {
            if (!this.headerSections.includes(button.closest('header-section'))) return;
            if (button.classList.contains('menu-button-active')) return;

            const closeWithoutAnimation = hasDropdownMenu || hasMegaMenu;
            const visibleMegaMenu = this.getVisibleMegaMenu();
            const visibleDropdown = this.getVisibleDropdown();

            if (hasMegaMenu && visibleMegaMenu) return;
            if (!visibleMegaMenu && !visibleDropdown) return;

            helpers.addEventInfo(event, 'onButtonsMouseenter');

            if (visibleMegaMenu) {
              closeWithoutAnimation ? visibleMegaMenu.megaMenuCloseWithoutAnimation() : visibleMegaMenu.megaMenuClose(event);
            } else if (visibleDropdown) {
              closeWithoutAnimation ? visibleDropdown.dropdownMenuCloseWithoutAnimation() : visibleDropdown.dropdownMenuClose(event);
            }
          }

          getVisibleMegaMenu() {
            return helpers.findElementsByClass(this.megaMenus, 'mega-menu--visible')[0];
          }

          getVisibleDropdown() {
            return helpers.findElementsByClass(this.dropdownMenus, 'dropdown-menu--visible')[0];
          }

          getMegaMenuByHandle(handle, ownerElement = null) {
            if (!handle) return null;

            const candidates = Array.from(this.wrapper?.querySelectorAll(`mega-menu[data-link-handle="${handle}"]`) || []);
            const ownerSection = ownerElement?.closest?.('header-section') || null;
            const blockId = ownerElement?.dataset?.megaMenuBlockId || null;

            if (ownerSection && blockId) {
              const sectionBlockMatch = candidates.find((element) => element.dataset?.megaMenuBlockId === blockId && element.closest('header-section') === ownerSection);
              if (sectionBlockMatch) return sectionBlockMatch;
            }

            if (ownerSection) {
              const sectionMatch = candidates.find((element) => element.closest('header-section') === ownerSection);
              if (sectionMatch) return sectionMatch;
            }

            if (blockId) {
              const blockMatch = candidates.find((element) => element.dataset?.megaMenuBlockId === blockId);
              if (blockMatch) return blockMatch;
            }

            return candidates.find(Boolean) || null;
          }

          getButtonByHandle(handle, megaMenu = null) {
            if (!handle) return null;

            let candidates = this.headerSections
              .flatMap((section) => Array.from(section.querySelectorAll(`[data-menu-button="${handle}"]`)));
            const ownerSection = megaMenu?.closest?.('header-section') || null;
            const blockId = megaMenu?.dataset?.megaMenuBlockId || null;
            let hasScopedCandidates = false;

            if (ownerSection) {
              const sectionCandidates = candidates.filter((element) => element.closest('header-section') === ownerSection);
              if (sectionCandidates.length) {
                candidates = sectionCandidates;
                hasScopedCandidates = true;
              }
            }

            if (blockId) {
              const blockCandidates = candidates.filter((element) => element.dataset?.megaMenuBlockId === blockId);
              if (blockCandidates.length) {
                candidates = blockCandidates;
                hasScopedCandidates = true;
              }
            }

            if (hasScopedCandidates) {
              return candidates.find((element) => this.isOpenOnClickElement(element)) || candidates.find(Boolean) || null;
            }

            return candidates.find(Boolean) || null;
          }

          getMegaMenuSectionRoot(host) {
            return host?.closest('[id^="shopify-section-"]') || null;
          }

          toggleMegaMenuHostState(host, state, enabled) {
            host?.classList.toggle(`mega-menus--${state}`, enabled);
          }

          toggleMegaMenuSectionState(host, enabled) {
            this.getMegaMenuSectionRoot(host)?.classList.toggle('shopify-section--mega-menu-active', enabled);
          }

          backgroundCloseWithoutAnimation(host = null) {
            const megaMenuHosts = host ? [host] : Array.from(this.megaMenuHosts || []);

            megaMenuHosts.forEach((megaMenuHost) => {
              megaMenuHost?.querySelector('.mega-menus__background')?.removeAttribute('style');
              megaMenuHost?.classList.remove('mega-menus--active', 'mega-menus--visible');
              this.toggleMegaMenuSectionState(megaMenuHost, false);
            });
          }

          prepareMegaMenuSwitch(nextMegaMenu) {
            const visibleMegaMenu = this.getVisibleMegaMenu();

            if (!visibleMegaMenu || visibleMegaMenu === nextMegaMenu) {
              return {
                preserveBackground: false,
                startHeight: 0,
              };
            }

            const preserveBackground = !!visibleMegaMenu.host && !!nextMegaMenu?.host && visibleMegaMenu.host === nextMegaMenu.host;

            if (!preserveBackground) {
              visibleMegaMenu.megaMenuCloseWithoutAnimation();

              return {
                preserveBackground: false,
                startHeight: 0,
              };
            }

            const sharedBackground = nextMegaMenu.background || visibleMegaMenu.background;
            const startHeight = sharedBackground ? getLogicalRect(sharedBackground).height || visibleMegaMenu.getVisibleContentHeight() : visibleMegaMenu.getVisibleContentHeight();

            visibleMegaMenu.contentCloseWithoutAnimation();

            return {
              preserveBackground: startHeight > 0,
              startHeight,
            };
          }

          allDropdownsCloseWithoutAnimation() {
            const visibleDropdown = this.getVisibleDropdown();

            if (visibleDropdown) visibleDropdown.dropdownMenuCloseWithoutAnimation();
          }

          calculateItemsAnimatedElements() {
            this.animateItemsRoots.forEach(root => {
              root.querySelectorAll('[data-menu-button]').forEach(button => {
                const icon = button.querySelector('.header__icons-menu-item-icon');
                const text = button.querySelector('.header__icons-menu-item-text');

                if (!icon || !text) return;

                button.style.setProperty('--item-icon-height', `${icon.offsetHeight / 10}rem`);
                button.style.setProperty('--item-text-height', `${text.offsetHeight / 10}rem`);

                button.classList.add('content-calculated');
              });
            });
          }
        }

        window.navigationControler = new NavigationControler;
        window.addEventListener('HeaderPrimaryMaybeChanged', () => {
          window.navigationControler?.init();
        });

        scriptController.onStyleReady(() => {
          class MegaMenuBasis extends HTMLElement {
            constructor() {
              super();
              this.onHeaderChangeHandler = this.onHeaderChange.bind(this);
              this.onCloseKeypressHandler = (event) => {
                if (event.key !== 'Enter') return;
                this.onButtonClick(event);
              };
            }

            connectedCallback() {
              this.duration = 300;
              this.spacer = this.querySelector('.mega-menu__spacer');
              this.content = this.querySelector('.mega-menu__content');
              this.close = this.querySelector('.mega-menu__close');

              if (!this.headerChangeBound) {
                window.addEventListener('HeaderPrimaryMaybeChanged', this.onHeaderChangeHandler);
                this.headerChangeBound = true;
              }

              if (this.close && !this.closeNavigationBound) {
                this.close.addEventListener('keypress', this.onCloseKeypressHandler);
                this.closeNavigationBound = true;
              }

              this.refreshBindings();
            }

            disconnectedCallback() {
              this.unbindPrimaryEvents?.();

              if (this.headerChangeBound) {
                window.removeEventListener('HeaderPrimaryMaybeChanged', this.onHeaderChangeHandler);
                this.headerChangeBound = false;
              }
            }

            refreshBindings() {
              this.unbindPrimaryEvents?.();

              this.button = navigationControler.getButtonByHandle(this.dataset.linkHandle, this);
              this.list = this.button?.closest('ul') || null;
              this.buttons = this.list?.querySelectorAll('[data-menu-button]') || [];
              this.host = this.closest('.mega-menus');
              this.background = this.host?.querySelector('.mega-menus__background') || null;

              if (!this.button || !this.list) return;

              this.bindPrimaryEvents?.();
            }

            onHeaderChange() {
              if (!this.isConnected) return;

              const wasVisible = this.classList.contains('mega-menu--visible');
              this.refreshBindings();

              if (wasVisible && !this.button) {
                this.contentCloseWithoutAnimation();
                navigationControler.backgroundCloseWithoutAnimation(this.host);
                navigationControler.toggleSharedState('mega-menu-active', false);
                navigationControler.toggleSharedState('mega-menu-visible', false);
              }
            }

            onButtonClick(event) {
              if (!this.isPrimaryHeaderSection()) return;

              event.preventDefault();
              if (event.type !== 'click' && event.key !== 'Enter') return;
              helpers.addEventInfo(event, 'onButtonClick');

              if (this.classList.contains('mega-menu--visible')) {
                this.megaMenuClose(event);
                if (this.shouldPreserveFocus(event)) {
                  this.button.focus();
                }
              } else {
                this.megaMenuOpen(event);
                if (this.shouldPreserveFocus(event)) {
                  this.close.focus();
                }
              }
            }

            shouldPreserveFocus(event) {
              return event?.key === 'Enter' || event?.detail === 0 || event?.type === 'keypress' || event?.type === 'keydown';
            }

            getVisibleContentHeight() {
              const contentHeight = this.content ? getLogicalRect(this.content).height : 0;
              const menuHeight = getLogicalRect(this).height || 0;

              return Math.max(contentHeight, menuHeight);
            }

            measureOpenHeight() {
              const wasVisible = this.classList.contains('mega-menu--visible');
              const previousStyle = this.getAttribute('style');

              if (!wasVisible) {
                this.classList.add('mega-menu--visible');
                this.style.visibility = 'hidden';
                this.style.pointerEvents = 'none';
              }

              const openHeight = this.getVisibleContentHeight();

              if (!wasVisible) {
                this.classList.remove('mega-menu--visible');

                if (previousStyle != null) {
                  this.setAttribute('style', previousStyle);
                } else {
                  this.removeAttribute('style');
                }
              }

              return openHeight;
            }

            syncBackgroundHeight() {
              if (!this.background) return;

              const openHeight = this.getVisibleContentHeight();

              if (openHeight > 0) {
                this.background.style.height = `${openHeight}px`;
              }
            }

            megaMenuOpen(event) {
              if (!this.isPrimaryHeaderSection()) return;
              if (!this.background || !this.host) return;

              helpers.addEventInfo(event, 'megaMenuOpen');

              animation.stop(this.background, false);

              const switchState = navigationControler.prepareMegaMenuSwitch(this);

              const openHeight = this.measureOpenHeight();
              const initialHeight = switchState.preserveBackground ? switchState.startHeight : 0;

              this.button.classList.add('menu-button-active');
              this.classList.add('mega-menu--visible');
              this.style.height = `${initialHeight}px`;
              this.style.overflow = 'hidden';
              this.background.style.height = `${initialHeight}px`;
              this.background.style.overflow = 'hidden';
              this.background.style.display = 'block';

              animation.animate(
                this.background, {
                  height: `${openHeight}px`,
                }, {
                  duration: this.duration,
                  duplicate: [this],
                  event: event,
                  complete: () => {
                    this.removeAttribute('style');
                    this.background.style.overflow = '';
                    requestAnimationFrame(() => this.syncBackgroundHeight());
                  }
                }
              );

              setTimeout(() => this.classList.add('mega-menu--active'));
              navigationControler.toggleMegaMenuHostState(this.host, 'visible', true);
              navigationControler.toggleMegaMenuSectionState(this.host, true);
              setTimeout(() => navigationControler.toggleMegaMenuHostState(this.host, 'active', true));
              navigationControler.toggleSharedState('mega-menu-visible', true);
              setTimeout(() => navigationControler.toggleSharedState('mega-menu-active', true));
            }

            megaMenuClose(event) {
              if (!this.isPrimaryHeaderSection()) return;
              if (!this.background || !this.host) return;

              if (!this.classList.contains('mega-menu--visible') || animation.hasEventInfo(this.background, 'megaMenuClose')) {
                return;
              }

              helpers.addEventInfo(event, 'megaMenuClose');
              animation.stop(this.background);

              animation.slideUp(
                this.background, {
                  duration: this.duration,
                  duplicate: [this],
                  complete: () => {
                    this.classList.remove('mega-menu--visible');
                    navigationControler.toggleMegaMenuHostState(this.host, 'visible', false);
                    navigationControler.toggleMegaMenuSectionState(this.host, false);
                    navigationControler.toggleSharedState('mega-menu-visible', false);
                  },
                  event: event
                }
              );

              this.button.classList.remove('menu-button-active');
              this.classList.remove('mega-menu--active');
              navigationControler.toggleMegaMenuHostState(this.host, 'active', false);
              navigationControler.toggleSharedState('mega-menu-active', false);
            }

            contentCloseWithoutAnimation() {
              this.button?.classList.remove('menu-button-active');
              this.removeAttribute('style');
              this.classList.remove('mega-menu--active', 'mega-menu--visible');
            }

            isPrimaryHeaderSection() {
              const ownerSection = this.button?.closest('header-section');
              const desktopSections = window.themeHeader?.getDesktopStackSections?.() || [];

              return !!ownerSection && desktopSections.includes(ownerSection);
            }

            megaMenuCloseWithoutAnimation() {
              document.body.classList.add('close-without-animation');
              if (this.background) {
                animation.stop(this.background, false);
              }
              this.contentCloseWithoutAnimation();
              navigationControler.backgroundCloseWithoutAnimation(this.host);
              navigationControler.toggleSharedState('mega-menu-active', false);
              navigationControler.toggleSharedState('mega-menu-visible', false);
              setTimeout(() => document.body.classList.remove('close-without-animation'));
            }
          }

          class MegaMenu extends MegaMenuBasis {
            constructor() {
              super();
              this.onButtonClickHandler = this.onButtonClick.bind(this);
              this.onDocumentClickHandler = this.onDocumentClick.bind(this);
              this.onContactMouseenterHandler = (event) => this.onDocumentClick(event, false);
              this.onTouchButtonClickHandler = (event) => {
                if (event.pointerType === 'mouse') return;
                this.onButtonClick(event);

                const link = this.button.tagName === 'A' ? this.button : this.button.querySelector('a');
                const href = link?.getAttribute('href') || null;

                if (href) {
                  window.location.href = href;
                }
              };
              this.onButtonMouseenterHandler = this.onButtonMouseenter.bind(this);
              this.onListMouseleaveHandler = this.onListMouseleave.bind(this);
              this.onMenuMouseleaveHandler = this.onMenuMouseleave.bind(this);
              this.onSpacerMouseleaveHandler = this.onSpacerMouseleave.bind(this);
            }

            isOpenOnClick() {
              return navigationControler.isOpenOnClickElement(this.button);
            }

            bindPrimaryEvents() {
              if (!this.button) return;

              if (this.isOpenOnClick()) {
                this.button.addEventListener('click', this.onButtonClickHandler);
                document.body.addEventListener('click', this.onDocumentClickHandler);
                this.contactElement = this.button.closest('header-section')?.querySelector('.header__contact') ||
                  navigationControler.headerSection?.querySelector('.header__contact') ||
                  null;
                this.contactElement?.addEventListener('mouseenter', this.onContactMouseenterHandler);
                return;
              }

              if (!this.list || !this.spacer) return;

              this.button.addEventListener('click', this.onTouchButtonClickHandler);
              this.button.addEventListener('mouseenter', this.onButtonMouseenterHandler);
              this.list.addEventListener('mouseleave', this.onListMouseleaveHandler);
              this.addEventListener('mouseleave', this.onMenuMouseleaveHandler);
              this.spacer.addEventListener('mouseleave', this.onSpacerMouseleaveHandler);
            }

            unbindPrimaryEvents() {
              this.button?.removeEventListener('click', this.onButtonClickHandler);
              this.button?.removeEventListener('click', this.onTouchButtonClickHandler);
              this.button?.removeEventListener('mouseenter', this.onButtonMouseenterHandler);
              this.list?.removeEventListener('mouseleave', this.onListMouseleaveHandler);
              this.removeEventListener('mouseleave', this.onMenuMouseleaveHandler);
              this.spacer?.removeEventListener('mouseleave', this.onSpacerMouseleaveHandler);
              document.body.removeEventListener('click', this.onDocumentClickHandler);
              this.contactElement?.removeEventListener('mouseenter', this.onContactMouseenterHandler);
              this.contactElement = null;
            }

            onDocumentClick(event, animation = true) {
              if (this.classList.contains('mega-menu--visible') && !helpers.containsOrIs(this.list, event.target) && !helpers.containsOrIs(this, event.target)) {
                helpers.addEventInfo(event, 'onDocumentClick');
                animation ? this.megaMenuClose(event) : this.megaMenuCloseWithoutAnimation(event);
              }
            }

            onButtonMouseenter(event) {
              if (helpers.containsOrIs(this, event.relatedTarget)) {
                return;
              }

              helpers.addEventInfo(event, 'onButtonMouseenter');
              this.megaMenuOpen(event);
            }

            onListMouseleave(event) {
              if (!this.classList.contains('mega-menu--visible') || helpers.containsOrIs(this, event.relatedTarget)) {
                return;
              }

              helpers.addEventInfo(event, 'onListMouseleave');
              this.megaMenuClose(event);
            }

            onMenuMouseleave(event) {
              if (helpers.findElement(navigationControler.buttons, event.relatedTarget)) {
                return;
              }

              helpers.addEventInfo(event, 'onMenuMouseleave');
              this.megaMenuClose(event);
            }

            onSpacerMouseleave(event) {
              if (event.relatedTarget === this.button) {
                return;
              }

              this.trimSpacer();
            }

            contentCloseWithoutAnimation() {
              super.contentCloseWithoutAnimation();
              if (!this.isOpenOnClick()) {
                this.spacerHide();
              }
            }

            megaMenuOpen(event) {
              super.megaMenuOpen(event);
              if (!this.isOpenOnClick()) {
                this.spacerShow();
              }
            }

            megaMenuClose(event) {
              super.megaMenuClose(event);
              if (!this.isOpenOnClick()) {
                this.spacerHide();
              }
            }

            spacerShow() {
              const megaMenuRect = getLogicalRect(this);
              const buttonRect = getLogicalRect(this.button);

              this.spacer.style.height = `${(megaMenuRect.top - buttonRect.bottom) / 10}rem`;
            }

            spacerHide() {
              this.spacer?.removeAttribute('style');
            }

            trimSpacer() {
              const buttonRect = getLogicalRect(this.button);

              this.spacer.style.width = `${buttonRect.width + 30}px`;
              this.spacer.style[getLogicalProperty('left')] = `${buttonRect.left - 15}px`;
            }
          }

          customElements.define('mega-menu', MegaMenu);
        }, ['section-mega-menu']);

        class DropdownMenuBasis extends HTMLElement {
          constructor() {
            super();
            this.onHeaderChangeHandler = this.onHeaderChange.bind(this);
          }

          connectedCallback() {
            this.duration = 300;
            this.button = this.querySelector('summary');
            if (!this.button) return;
            this.dropdown = this.querySelector('.header__submenu');
            this.list = this.button.closest('ul');
            this.buttons = this.list.querySelectorAll('[data-menu-button]');
            this.content = this.querySelector('.header__submenu');
            this.urlButtons = this.querySelectorAll('[data-url]');

            if (!this.staticEventsBound) {
              const detailsButton = this.button.closest('details');
              const detailsButtons = detailsButton.querySelectorAll('details');

              [...detailsButtons, detailsButton].forEach(element => element.setAttribute('open', true));
              detailsButtons.forEach(element => {
                element.querySelector('summary').addEventListener('click', this.onChildSummaryClick.bind(this));
                element.addEventListener('click', event => {
                  this.onChildClick(event, element);
                });
                element.addEventListener('mouseenter', this.onChildMouseenter.bind(this));
                element.addEventListener('mouseleave', this.onChildMouseleave.bind(this));
              });
              this.urlButtons.forEach(element => {
                element.addEventListener('click', () => {
                  window.location.href = element.dataset.url;
                });
              });

              this.staticEventsBound = true;
            }

            if (!this.headerChangeBound) {
              window.addEventListener('HeaderPrimaryMaybeChanged', this.onHeaderChangeHandler);
              this.headerChangeBound = true;
            }

            this.refreshBindings();
          }

          disconnectedCallback() {
            this.unbindInteractiveEvents?.();

            if (this.headerChangeBound) {
              window.removeEventListener('HeaderPrimaryMaybeChanged', this.onHeaderChangeHandler);
              this.headerChangeBound = false;
            }
          }

          refreshBindings() {
            this.unbindInteractiveEvents?.();
            this.headerSection = this.closest('header-section');

            if (!this.isPrimaryHeaderSection()) return;
            if (navigationControler.getMegaMenuByHandle(this.button.dataset.menuButton, this.button)) return;

            this.bindInteractiveEvents?.();
          }

          onHeaderChange() {
            if (!this.isConnected) return;

            const wasVisible = this.classList.contains('dropdown-menu--visible');
            this.refreshBindings();

            if (wasVisible && !this.isPrimaryHeaderSection()) {
              this.dropdownMenuCloseWithoutAnimation();
            }
          }

          onChildSummaryClick(event) {
            event.preventDefault();
          }

          onChildClick(event, element) {
            if (event.pointerType === 'mouse') return;

            const submenu = element.querySelector('.header__submenu');

            if (!submenu.classList.contains('header__submenu--visible')) {
              this.onChildMouseenter(event, element);
            } else {
              this.onChildMouseleave(event, element);
            }
          }

          onChildMouseenter(event, element) {
            const target = element || event.target;
            const submenu = target.querySelector('.header__submenu');
            const width = parseInt(getComputedStyle(submenu).width);
            const itemRect = getLogicalRect(target);

            submenu.classList[itemRect.right + width + 20 >= document.documentElement.clientWidth ? 'add' : 'remove']('header__submenu--right');
            submenu.classList.add('header__submenu--visible');
            setTimeout(() => submenu.classList.add('header__submenu--active'), 10);
          }

          onChildMouseleave(event, element) {
            const target = element || event.currentTarget;
            const submenu = target.querySelector('.header__submenu');

            submenu.classList.remove('header__submenu--visible', 'header__submenu--active');
          }

          dropdownMenuOpen(event) {
            if (!this.isPrimaryHeaderSection()) return;

            helpers.addEventInfo(event, 'dropdownMenuOpen');
            animation.stop(this.dropdown, false);
            navigationControler.allDropdownsCloseWithoutAnimation();

            const submenu = this.querySelector('.header__submenu');
            const itemRect = getLogicalRect(this.button);

            submenu.classList[itemRect.left + 210 >= document.documentElement.clientWidth ? 'add' : 'remove']('header__submenu--right');
            animation.slideDown(
              this.dropdown, {
                duration: this.duration,
                event: event
              }
            );
            this.button.classList.add('menu-button-active');
            this.classList.add('dropdown-menu--visible');
            setTimeout(() => this.classList.add('dropdown-menu--active'));
            navigationControler.toggleSharedState('dropdown-menu-visible', true);
            setTimeout(() => navigationControler.toggleSharedState('dropdown-menu-active', true));
          }

          dropdownMenuClose(event) {
            if (!this.isPrimaryHeaderSection()) return;

            if (!this.classList.contains('dropdown-menu--visible') || animation.hasEventInfo(this.dropdown, 'dropdownMenuClose')) return;

            helpers.addEventInfo(event, 'dropdownMenuClose');
            animation.stop(this.dropdown);
            animation.slideUp(
              this.dropdown, {
                duration: this.duration,
                complete: () => {
                  this.classList.remove('dropdown-menu--visible');
                  navigationControler.toggleSharedState('dropdown-menu-visible', false);
                },
                event: event
              }
            );
            this.button.classList.remove('menu-button-active');
            this.classList.remove('dropdown-menu--active');
            navigationControler.toggleSharedState('dropdown-menu-active', false);
          }

          dropdownMenuCloseWithoutAnimation() {
            document.body.classList.add('close-without-animation');
            animation.stop(this.dropdown, false);
            this.button.classList.remove('menu-button-active');
            this.classList.remove('dropdown-menu--active', 'dropdown-menu--visible');
            this.dropdown.removeAttribute('style');
            navigationControler.toggleSharedState('dropdown-menu-active', false);
            navigationControler.toggleSharedState('dropdown-menu-visible', false);
            setTimeout(() => document.body.classList.remove('close-without-animation'), 10);
          }

          onButtonClick(event) {
            if (!this.isPrimaryHeaderSection()) return;

            helpers.addEventInfo(event, 'onButtonClick');

            if (this.classList.contains('dropdown-menu--visible')) {
              this.dropdownMenuClose(event);
            } else {
              this.dropdownMenuOpen(event);
            }
          }

          isPrimaryHeaderSection() {
            const ownerSection = this.headerSection || this.closest('header-section');
            const desktopSections = window.themeHeader?.getDesktopStackSections?.() || [];

            return !!ownerSection && desktopSections.includes(ownerSection);
          }
        }

        class DropdownMenu extends DropdownMenuBasis {
          constructor() {
            super();
            this.onButtonClickHandler = (event) => {
              if (event.pointerType !== 'mouse' || (event.pointerType === 'mouse' && !this.hasMegaMenu)) {
                event.preventDefault();
                this.onButtonClick(event);
              }
            };
            this.onDocumentClickHandler = this.onDocumentClick.bind(this);
            this.onTouchClickHandler = (event) => {
              if (event.pointerType === 'mouse') return;
              event.preventDefault();
              this.onButtonClick(event);
            };
            this.onButtonMouseenterHandler = this.onButtonMouseenter.bind(this);
            this.onListMouseleaveHandler = this.onListMouseleave.bind(this);
          }

          isOpenOnClick() {
            return navigationControler.isOpenOnClickElement(this.button);
          }

          bindInteractiveEvents() {
            if (!this.button || this.button.dataset.linkHandle) return;

            this.hasMegaMenu = navigationControler.getMegaMenuByHandle(this.button.dataset.menuButton, this.button);

            if (this.isOpenOnClick()) {
              this.button.addEventListener('click', this.onButtonClickHandler);

              if (this.hasMegaMenu) return;

              document.body.addEventListener('click', this.onDocumentClickHandler);
              return;
            }

            if (this.hasMegaMenu) return;

            this.button.addEventListener('click', this.onTouchClickHandler);
            this.button.addEventListener('mouseenter', this.onButtonMouseenterHandler);
            this.list?.addEventListener('mouseleave', this.onListMouseleaveHandler);
          }

          unbindInteractiveEvents() {
            this.button?.removeEventListener('click', this.onButtonClickHandler);
            this.button?.removeEventListener('click', this.onTouchClickHandler);
            this.button?.removeEventListener('mouseenter', this.onButtonMouseenterHandler);
            this.list?.removeEventListener('mouseleave', this.onListMouseleaveHandler);
            document.body.removeEventListener('click', this.onDocumentClickHandler);
          }

          onDocumentClick(event) {
            if (this.classList.contains('dropdown-menu--visible') && !helpers.containsOrIs(this.list, event.target)) {
              helpers.addEventInfo(event, 'onDocumentClick');
              this.dropdownMenuClose(event);
            }
          }

          onButtonMouseenter(event) {
            if (this.classList.contains('dropdown-menu--visible') && this.classList.contains('dropdown-menu--active')) {
              return;
            }

            helpers.addEventInfo(event, 'onButtonMouseenter');
            this.dropdownMenuOpen(event);
          }

          onListMouseleave(event) {
            if (!this.classList.contains('dropdown-menu--visible') || helpers.containsOrIs(this.dropdown, event.relatedTarget)) {
              return;
            }

            helpers.addEventInfo(event, 'onListMouseleave');
            this.dropdownMenuClose(event);
          }

          onMenuMouseleave(event) {
            if (event.relatedTarget === this.dropdown || event.relatedTarget === this.button) {
              return;
            }

            helpers.addEventInfo(event, 'onMenuMouseleave');
            this.dropdownMenuClose(event);
          }
        }

        customElements.define('dropdown-menu', DropdownMenu);

        if (themeBase.mouseX > 0 && themeBase.mouseY > 0) {
          function emulateMouseEnter() {
            const mouseElement = document.elementFromPoint(themeBase.mouseX, themeBase.mouseY);
            const menuButton = mouseElement?.closest('[data-menu-button]');

            if (!mouseElement || !mouseElement.closest('nav')) return;
            if (menuButton && navigationControler.isOpenOnClickElement(menuButton)) return;

            const event = new MouseEvent('mouseenter', {
              bubbles: true,
              cancelable: true,
              view: window
            });

            mouseElement.dispatchEvent(event);
          };

          emulateMouseEnter();
        }

        window.removeEventListener('mousemove', window.onMousemoveMonitor);
      });
    }

    window.navJsLoaded = true;
  });
});